import React from 'react';
import { StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import Panel from 'components/general/panel';

export const Answers = ({ data, setShow }) => {
    if (!data || data.length === 0) return null;
    const requests = data.reduce((a, d) => (a.some(y => y.id === d.id) ? a : a.concat([d])), []);
    const total = requests.length;

    const message = SystemText(`Home/Widgets/WhatsHappening/Answers`, total);

    // const message = `You've had answers on ${total} of your Knowledge Bank ${StringHelpers.pluralise('question', total)}.`;

    const url = total === 1 ? `/knowledge-bank/${data[0].id}` : '';

    return <Panel colour="success" icon="question" message={message} url={url} setShow={setShow} />;
};

export default Answers;
